import type { DeleteRoleDialogProps } from "./types-delete-role-dialog";
import { useDeleteRoleDialog } from "./use-delete-role-dialog";
import { DeleteRoleDialogView } from "./view-delete-role-dialog";

/** Pop-up de confirmação da exclusão de perfil (HU 870, Figma 4663:284395). */
export function DeleteRoleDialog(props: DeleteRoleDialogProps) {
  const vm = useDeleteRoleDialog(props);

  return <DeleteRoleDialogView {...vm} />;
}

export type * from "./types-delete-role-dialog";
